module.exports = __webpack_public_path__ + "img/it.1408b265.png";